module.exports = __webpack_public_path__ + "img/seloMedalhaBronze.698de172.png";